import pdfMake from 'pdfmake/build/pdfmake'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import EventEmitter, { SHOW_POPUP_PDF } from '../../helpers/EventEmitter'
import { FORMAT, formatDateTime } from '../../helpers/datetime'
import { uploadFileDynamic } from '../../tool/dynamicReport/store/thunk'
import useViewport from '../hooks/useViewport'
import { PopupAction } from './PopupAction'

export const PopupShowPdf = () => {
  const dispatch = useDispatch()
  const { width, height } = useViewport()
  const [data, setData] = useState(null)
  const [isDisable, setDisable] = useState(false)

  useEffect(() => {
    EventEmitter.subscribe(SHOW_POPUP_PDF, setData)
    return () => EventEmitter.unsubscribe(SHOW_POPUP_PDF, setData)
  }, [])

  const handleClose = () => {
    if (isDisable) return
    if (data?.closeFunction) {
      dispatch(data?.closeFunction())
    }

    setData(null)
  }

  const onSubmit = async () => {
    setDisable(true)
    if (data?.blobData && data?.docDefinition) {
      const nameFileDownload = `FG_DynamicReport_${formatDateTime(
        new Date(),
        FORMAT.FILE_DOWNLOAD,
      )}.pdf`

      let filePdfToServer = new File([data.blobData], nameFileDownload, {
        type: 'application/pdf',
      })

      let bodyFormData = new FormData()

      bodyFormData.append('file', filePdfToServer)

      await dispatch(uploadFileDynamic(bodyFormData)).unwrap()

      await pdfMake.createPdf(data.docDefinition).download(nameFileDownload)
      setDisable(false)
      return
    }
    setDisable(false)
  }

  return (
    <PopupAction
      title="dynamicReport.REPORT_PREVIEW"
      isShow={data !== null}
      handleClose={handleClose}
      btnSubmit={{
        label: data?.button || 'dynamicReport.EXPORT_REPORT',
        style: {},
        event: onSubmit,
        isI18n: true,
        disabled: isDisable,
      }}
      btnCancel={{
        label: data?.button || 'common.CLOSE',
        style: {},
        event: handleClose,
        isI18n: true,
        disabled: isDisable,
      }}
      appendStyle={{
        width: 0.95 * width,
        padding: '20px 20px 8px 20px',
        backgroundColor: '#F3F3F3',
        borderRadius: '4px',
      }}
    >
      <div
        style={{
          height: 0.8 * height,
          maxHeight: 884,
          position: 'relative',
        }}
      >
        {data?.children || (
          <>{data?.messages && <Fragment>{data?.messages}</Fragment>}</>
        )}
      </div>
    </PopupAction>
  )
}
